import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { safeDefineCustomElement } from 'lib-shared';
import { CommonModule } from '@angular/common';
import { createCustomElement } from '@angular/elements';
import { TableComponent } from './table.component';
import { IconColorPipe } from './icon-color.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [TableComponent, IconColorPipe],
  exports: [TableComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TableModule {
  constructor(private injector: Injector) {
    const control = createCustomElement(TableComponent, { injector: this.injector });
    safeDefineCustomElement('finra-table', control);
  }
}
